import React from "react";
import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import RecommendationRequestDetails from "./recommendation_request_details";

export default GrComponentFactory.createClass({
  displayName: "RecommendationRequestNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape({
      body: React.PropTypes.string.isRequired,
      url: React.PropTypes.string.isRequired,
      user: GrPropTypes.user().isRequired,
    }),
  },

  render() {
    const body = <RecommendationRequestDetails {...this.props.resource}/>;
    return <SocialUpdate
        header={<span>is looking for a book recommendation</span>}
        body={body}
        {...this.props}
      />;
  },
});

